@if (initialize) {
  <pos-inventory-product-edit (close)="onClose($event)" [additionalParameters]="parameters" [isScroll]="true"
    [inventoryProductId]="productid" (formChange)="onFormChange($event)">
  </pos-inventory-product-edit>
}
